import {createSlice, Dispatch} from '@reduxjs/toolkit';
import {SeatClassResponse, SeatClassStatus} from 'app/types/service-types/AircraftTypes';
import {SeatClassService} from 'app/services';

interface FetchSeatClassesParams {
  page?: number;
  size?: number;
  status?: SeatClassStatus;
}

export const fetchAllSeatClasses = (params?: FetchSeatClassesParams) => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const response = await SeatClassService.getAll(params);
    // Handle both paginated and non-paginated responses
    if ('content' in response) {
      dispatch(setSeatClasses(response.content));
      dispatch(setPagination({
        totalPages: response.totalPages || 0,
        totalElements: response.totalElements || 0,
        currentPage: response.number || 0,
        pageSize: response.size || 20
      }));
    } else {
      // Legacy non-paginated response
      dispatch(setSeatClasses(response));
    }
  } catch (err) {
    console.log(err);
  }
  dispatch(setLoading(false));
}

interface SeatClassesSlice {
  seatClasses: SeatClassResponse[];
  loading: boolean;
  pagination: {
    totalPages: number;
    totalElements: number;
    currentPage: number;
    pageSize: number;
  };
}

const initialState: SeatClassesSlice = {
  seatClasses: [],
  loading: false,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 20
  }
}

const stateSlice = createSlice({
  name: 'aircrafts/seat-classes',
  initialState,
  reducers: {
    setLoading: (state, action) => { state.loading = action.payload },
    setSeatClasses: (state, action) => { state.seatClasses = action.payload },
    setPagination: (state, action) => { state.pagination = action.payload }
  }
});

export const {setLoading, setSeatClasses, setPagination} = stateSlice.actions;
export default stateSlice.reducer;
